module.exports = __webpack_public_path__ + "static/media/nomad-logo-horizontal.76606640.png";